import SettingsIcon from "@mui/icons-material/Settings";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  DEFAULT_DISTANCE_DECIMALS,
  DISTANCE_DECIMAL_OPTIONS,
  DistanceDecimals,
} from "@/constants/distanceDecimals";

interface SettingsPopupProps {
  vehicleStatus?: boolean;
  setVehicleStatus?: (status: boolean) => void;
  allowArchivedFilters?: boolean;
  distanceDecimals?: DistanceDecimals;
  setDistanceDecimals?: (decimals: DistanceDecimals) => void;
}

const SettingsPopup: React.FC<SettingsPopupProps> = ({
  vehicleStatus = false,
  setVehicleStatus,
  allowArchivedFilters = true,
  distanceDecimals = DEFAULT_DISTANCE_DECIMALS,
  setDistanceDecimals,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const { t } = useTranslation();
  return (
    <>
      <IconButton onClick={handleClick}>
        <SettingsIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: { width: "250px" },
        }}
      >
        <Box p={2}>
          {allowArchivedFilters && (
            <>
              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>
                {t("device")}
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={vehicleStatus}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setVehicleStatus?.(event.target.checked)
                      }
                    />
                  }
                  label={t("logbookCheck.showArchived")}
                />
              </FormGroup>
            </>
          )}
          {setDistanceDecimals && (
            <>
              <Typography
                variant="subtitle1"
                gutterBottom
                style={{ fontWeight: 600 }}
                sx={{ mt: allowArchivedFilters ? 2 : 0 }}
              >
                {t("distance")}
              </Typography>
              <RadioGroup
                value={String(distanceDecimals)}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setDistanceDecimals(Number(event.target.value) as DistanceDecimals)
                }
              >
                {DISTANCE_DECIMAL_OPTIONS.map(option => (
                  <FormControlLabel
                    key={option}
                    value={String(option)}
                    control={<Radio />}
                    label={t("logbookCheck.distanceDecimals", { count: option })}
                  />
                ))}
              </RadioGroup>
            </>
          )}
        </Box>
      </Popover>
    </>
  );
};

export default SettingsPopup;
